<ion-list *ngIf="loading">
  <ion-item>
    <ion-label style="display: flex; justify-content: space-between; align-items: center;">
      <ion-skeleton-text [animated]="true" style="width: 4%;"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" style="width: 8%;"></ion-skeleton-text>
    </ion-label>
  </ion-item>
    <ion-item>
    <ion-label style="display: flex; justify-content: space-between; align-items: center;">
      <ion-skeleton-text [animated]="true" style="width: 4%;"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" style="width: 8%;"></ion-skeleton-text>
    </ion-label>
  </ion-item>
    <ion-item>
    <ion-label style="display: flex; justify-content: space-between; align-items: center;">
      <ion-skeleton-text [animated]="true" style="width: 4%;"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" style="width: 8%;"></ion-skeleton-text>
    </ion-label>
  </ion-item>
    <ion-item>
    <ion-label style="display: flex; justify-content: space-between; align-items: center;">
      <ion-skeleton-text [animated]="true" style="width: 4%;"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" style="width: 8%;"></ion-skeleton-text>
    </ion-label>
  </ion-item>
    <ion-item>
    <ion-label style="display: flex; justify-content: space-between; align-items: center;">
      <ion-skeleton-text [animated]="true" style="width: 4%;"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" style="width: 8%;"></ion-skeleton-text>
    </ion-label>
  </ion-item>
    <ion-item>
    <ion-label style="display: flex; justify-content: space-between; align-items: center;">
      <ion-skeleton-text [animated]="true" style="width: 4%;"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" style="width: 8%;"></ion-skeleton-text>
    </ion-label>
  </ion-item>
</ion-list>


<ion-list lines="full" class="ion-no-padding available-appointments">
  <ng-container *ngFor="let slot of slots">

    <ion-item *ngIf="doWeShowSlot(slot)" lines="none" class="available-appointments__item clickable" [ngClass]="{ 'available-appointments__item--dropdown-active': isSlotPicked(slot) && eventFilter === 'all' && ( slot.events.length > 1 || slot.events.length == 1 && slot.regularOfferAvailable ), 'available-appointments__item--selected': ('restavracija-strelec' !== real?.slug && 'jaz-by-me' !== real?.slug) &&isSlotPicked(slot) &&  ( eventFilter !== 'all' || ( slot.events.length === 0 || ( slot.events.length == 1 && ( !slot.regularOfferAvailable || ( real.hideALaCarteOption && real.hideCannotDecideOption ) ) ) ) ), 'available-appointments__item--selected-secondary': ('restavracija-strelec' == real?.slug || 'jaz-by-me' == real?.slug) && isSlotPicked(slot) &&  ( eventFilter !== 'all' || ( slot.events.length === 0 || slot.events.length == 1 && !slot.regularOfferAvailable ) ) }" [color]="isSlotPicked(slot)?'none':'none'" (click)="toggleSlot(slot)">
        <ion-grid class="ion-no-padding" [ngClass]="{ 'dropdown--opened': isSlotPicked(slot) && slot.otherCombinationsAvailable }">
          <ion-row class="ion-align-items-center ion-no-padding">
            <ion-col size="2" >{{ getTime( slot.start ) }}</ion-col>
            
            <ion-col size="1" class="col--main">
              <ng-container *ngFor="let employeeApiHref of slot.employees; let l = count">
                <div class="img-container">
                <img [src]= "getAvatarFileFromEmployeeHref(employeeApiHref) | ppImage">
                </div>
                <span *ngIf="l===1">{{ getNameFromEmployeeHref( employeeApiHref ) }}</span>
              </ng-container>
            </ion-col>


            <ion-col size="9" class="ion-text-end"><span *ngIf="slot.priceRange.max != slot.priceRange.min">od&nbsp;</span>

              <ng-container *ngIf="servicesSnapshot && slot.events">
                <!--ion-button style="margin:2px 0px 0 10px;" *ngIf="( ( eventFilter !== 'all' && slot.events.length > 0 ) || ( eventFilter === 'all' && slot.events.length === 1 && !slot.regularOfferAvailable ))" (click)="openOfferInfoModal(servicesSnapshot['id_' + slot.events[0]]); $event.stopPropagation();" md="ios" fill="clear" color="medium"><ion-icon name="information-circle-outline" [style.color]="isSlotPicked(slot)?'white':'black'" style="margin-right:0px;"></ion-icon></ion-button-->

                <!-- Slot protected by payment-->
                <ion-button *ngIf="showPaymentProtectionIcon( slot, eventFilter, servicesSnapshot, real )" style="margin:2px 0px 0 5px;" (click)="openPaymentInfoModalFromEventFilter(slot.events, eventFilter); $event.stopPropagation();" md="ios" fill="clear" color="medium">
                  <ion-icon [style.color]="(isSlotPicked(slot)?'white':'black')" name="card-outline"></ion-icon></ion-button>

                 <span *ngIf="( eventFilter !== 'all' && slot.events.length > 0 ) || ( eventFilter === 'all' && slot.events.length === 1 && !slot.regularOfferAvailable ) || ( eventFilter === 'all' && slot.events.length === 1 && slot.regularOfferAvailable && real.hideCannotDecideOption && real.hideALaCarteOption)">{{ getSlotText( slot.events, eventFilter, translateService.currentLang ) }} </span>

                <ion-button style="margin:2px 0px 0 5px;" *ngIf="( ( eventFilter !== 'all' && slot.events.length > 0 ) || ( eventFilter === 'all' && slot.events.length === 1 && !slot.regularOfferAvailable ))" (click)="openOfferInfoModalFromEventFilter(slot.events, eventFilter); $event.stopPropagation();" md="ios" fill="clear" color="medium"><!--ion-img style="width:20px;" [src]="isSlotPicked(slot)?'/assets/images/info_white.png':'/assets/images/info.png'"></ion-img-->
                  <ion-icon [style.color]="(isSlotPicked(slot)?'white':'black')" name="information-circle-outline"></ion-icon></ion-button>

                
                <span *ngIf="slot.events.length == 0">{{ 'HARDCODED_EVENTS.TABLE_FOR' | translate }} {{pick.partySize}}</span>
                <span *ngIf="eventFilter === 'all' && ( slot.events.length > 1 || (slot.events.length === 1 && slot.regularOfferAvailable && ( !real.hideCannotDecideOption || !real.hideALaCarteOption ) ) )">{{ getMoreOptionsSlotText( slot.events, slot.regularOfferAvailable, translateService.currentLang ) }}</span>

              </ng-container>

              <!--ng-container *ngIf="pick.shopId == 2584">
                <span *ngIf="isSilvester( slot.start )">{{ 'HARDCODED_EVENTS.SILVESTER' | translate }}</span>
              </ng-container>
              <ng-container *ngIf="pick.shopId == 2798">
                <span *ngIf="isBrunch( slot.start )">Šampanjski brunch</span>
                <span *ngIf="isSilvester( slot.start )">{{ 'HARDCODED_EVENTS.SILVESTER' | translate }}</span>
              </ng-container>
              <ng-container *ngIf="pick.shopId == 2671">
                <span>{{ 'HARDCODED_EVENTS.SEASONAL_MENU' | translate }}</span>
              </ng-container>
              <ng-container *ngIf="pick.shopId != 2584 && pick.shopId != 2798 && pick.shopId != 2671">
                <span>{{ 'HARDCODED_EVENTS.TABLE_FOR' | translate }} {{pick.partySize}}</span>
              </ng-container-->

             </ion-col>  
          </ion-row>
        </ion-grid>
    </ion-item>

    <div class="available-appointments__item--dropdown-active" *ngIf="isSlotPicked(slot) && eventFilter === 'all' && ( slot.events.length > 1 || slot.events.length == 1 && ( slot.regularOfferAvailable  && ( !real.hideALaCarteOption || !real.hideCannotDecideOption )  )   )" >
      <ng-template #foo>
        <ion-grid> 
          <ion-row class="ion-align-items-center"><ion-col class="ion-text-center"><ion-spinner name="crescent"></ion-spinner></ion-col></ion-row>
        </ion-grid>
      </ng-template>

      <ng-container *ngIf="servicesSnapshot">
        <ion-list lines="full" class="ion-no-padding ion-no-margin clickable">
          
          <ion-item *ngFor="let e of slot.events" (click)="toggleCombination( slot, e )" color="none" lines="none" class="available-appointments__item" [ngClass]="{'available-appointments__item--selected': (eventPreference === e) }">
              <ion-grid  class="ion-no-padding">
                <ion-row class="ion-align-items-center ion-no-padding">
                  <ion-col size="2" class="ion-text-center"></ion-col>
                  <ion-col size="7" class="col--main"><ion-button  *ngIf="( servicesSnapshot['id_' + e].noShowProtection || servicesSnapshot['id_' + e].paymentRequired || servicesSnapshot['id_' + e].minSpendRequired )" style="margin:2px 0px 0px 0px; --padding-start:0px;" (click)="openPaymentInfoModal(servicesSnapshot['id_' + e]); $event.stopPropagation();" md="ios" fill="clear" color="medium">
                  <ion-icon [style.color]="((eventPreference === e)?'white':'black')" name="card-outline"></ion-icon></ion-button><!--span style="margin-left:30px;"></span-->{{ servicesSnapshot['id_' + e].name | ppTranslate: servicesSnapshot['id_' + e].nameTranslations:translateService.currentLang}}
                  </ion-col>            
                  <ion-col size="3" class="ion-text-end"><ion-button style="margin:0px;" fill="clear" (click)="openOfferInfoModal(servicesSnapshot['id_' + e]); $event.stopPropagation();" color="secondary"><!--ion-img *ngIf="(eventPreference !== e)" style="width:20px;" [src]="'/assets/images/info.png'"></ion-img-->
                    <!--ion-img *ngIf="(eventPreference === e)" style="width:20px;" [src]="'/assets/images/info_white.png'"></ion-img--><ion-icon [style.color]="((eventPreference === e)?'white':'black')" name="information-circle-outline"></ion-icon></ion-button></ion-col>            
                </ion-row>
              </ion-grid>
          </ion-item>

          <ion-item (click)="toggleCombination( slot, null )" color="none" lines="none" *ngIf="slot.regularOfferAvailable  && !real.hideALaCarteOption &&  ( !real.aLaCarteMenu || real.aLaCarteMenu !== 'skrij' )" class="available-appointments__item" [ngClass]="{'available-appointments__item--selected': (eventPreference === null) }">
              <ion-grid  class="ion-no-padding">
                <ion-row class="ion-align-items-center ion-no-padding">
                  <ion-col size="2" class="ion-text-center"></ion-col>
                  <ion-col size="7" class="col--main"><ion-button *ngIf="( ( real?.noShowProtection && real?.hasSlotNoShowProtection( slot.start ) ) || real?.paymentRequired || real?.minSpendRequired )" style="margin:2px 0px 0px 0px; --padding-start:0px;" (click)="openPaymentInfoModalFromEventFilter(slot.events, eventFilter); $event.stopPropagation();" md="ios" fill="clear" color="medium">
                  <ion-icon [style.color]="((eventPreference === null)?'white':'black')" name="card-outline"></ion-icon></ion-button>À la carte
                  </ion-col>            
                  <ion-col size="3" class="ion-text-end"></ion-col>            
                </ion-row>
              </ion-grid>
          </ion-item>

          <ion-item (click)="toggleCombination( slot, 'cannotDecide' )" color="none" lines="none" *ngIf="!real.hideCannotDecideOption && slot.regularOfferAvailable" class="available-appointments__item" [ngClass]="{'available-appointments__item--selected': (eventPreference === 'cannotDecide') }">
              <ion-grid  class="ion-no-padding">
                <ion-row class="ion-align-items-center ion-no-padding">
                  <ion-col size="2" class="ion-text-center"></ion-col>
                  <ion-col size="7" class="col--main"><ion-button *ngIf="( ( real?.noShowProtection && real?.hasSlotNoShowProtection( slot.start ) ) || real?.paymentRequired || real?.minSpendRequired )" style="margin:2px 0px 0px 0px; --padding-start:0px;" (click)="openPaymentInfoModalFromEventFilter(slot.events, eventFilter); $event.stopPropagation();" md="ios" fill="clear" color="medium">
                  <ion-icon [style.color]="((eventPreference === 'cannotDecide')?'white':'black')" name="card-outline"></ion-icon></ion-button>{{ 'PICK_SLOT.CANNOT_DECIDE' | translate }}
                  </ion-col>            
                  <ion-col size="3" class="ion-text-end"></ion-col>            
                </ion-row>
              </ion-grid>
          </ion-item>

          <!--ion-item (click)="combinationPicked=2;" color="none" lines="none" class="available-appointments__item" [ngClass]="{'available-appointments__item--selected': (combinationPicked === 2) }">
              <ion-grid  class="ion-no-padding">
                <ion-row class="ion-align-items-center ion-no-padding">
                  <ion-col size="2" class="ion-text-center"></ion-col>
                  <ion-col size="7" class="col--main">Še ne vem, samo rezervacija.
                  </ion-col>            
                  <ion-col size="3" class="ion-text-end"></ion-col>            
                </ion-row>
              </ion-grid>
          </ion-item-->

          
        </ion-list>
      </ng-container>
    </div>

   

    <div class="available-appointments__item--dropdown-active" *ngIf="isSlotPicked(slot) && slot.otherCombinationsAvailable" >
      <ng-template #foo>
        <ion-grid> 
          <ion-row class="ion-align-items-center"><ion-col class="ion-text-center"><ion-spinner name="crescent"></ion-spinner></ion-col></ion-row>
        </ion-grid>
      </ng-template>
      <ng-container *ngIf="slotCombinations$ | async as slotCombinations; else foo">
        <ion-list lines="full" class="ion-no-padding ion-no-margin clickable">
          <ion-item color="none" lines="none" class="available-appointments__item" [ngClass]="{'available-appointments__item--selected': isCombinationPicked(c) }" (click)="toggleCombination(c); $event.stopPropagation();" *ngFor="let c of slotCombinations">
              <ion-grid  class="ion-no-padding">
                <ion-row class="ion-align-items-center ion-no-padding">
                  <ion-col size="2" class="ion-text-center">{{ ( c.durationInSeconds / 60 ) | number:'1.0-0' }}'</ion-col>
                  <ion-col size="7" class="col--main">

                    <ng-container *ngFor="let attendee of c.attendees; let l = count">
                      <div class="img-container" *ngFor="let attendee of c.attendees">
                        <img [src]="getAvatarFileFromEmployeeHref(attendee?.services[0]?.employeeHref) | ppImage">
                      <i *ngIf="areThereMoreEmployeesPerAttendee( attendee?.services )" class="plus-sign material-icons">add_circle</i>
                      </div>
                      <span *ngIf="l===1">{{ getNameFromEmployeeHref( attendee?.services[0]?.employeeHref ) }}</span>
                    </ng-container>
                  </ion-col>            
                  <ion-col size="3" class="ion-text-end">{{ c.price?.amount | number:'1.2-2' }} €</ion-col>            
                </ion-row>
              </ion-grid>
          </ion-item>
        </ion-list>
      </ng-container>
    </div>

  </ng-container>
</ion-list>